import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';

import { TSegmentPeople } from '../types';

export async function deleteSegmentPeople(id: string): Promise<TSegmentPeople[]> {
  return mediaManagerClient.delete(`/api/v1/segment_people/${id}`).then(({ data }) => data);
}

type MutationFn = typeof deleteSegmentPeople;

type TUseDeleteSegmentPeopleParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDeleteSegmentPeople({ config }: TUseDeleteSegmentPeopleParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: deleteSegmentPeople,
    onError(error) {
      addErrorNotification(t('No se ha podido eliminar la persona de interés del segmento'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('La persona de interés del segmento se ha eliminado correctamente'));
    },
  });
}
